<template>
  <v-btn @click.stop="$emit('click')" aria-label="login" v-bind="btnProps">
    <v-icon class="icon-xl">{{icon}}</v-icon>
    <spacer width="10px" v-if="icon && text"/>
    <span class="font-15">{{ text }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'AddEstateBtn',

  props: {
    icon: {
      type: String,
      default: 'mdi-home-plus-outline'
    },
    text: {
      type: String,
      default: function () { return this.$t('main_header.add_property') }
    },
    size: {
      type: String,
      default: 'large'
    },
    color: {
      type: String,
      default: 'primary'
    },
    to: {
      type: Object,
      default: function () { return { name: 'new_estate' } }
    },
    width: String,
    height: String,
    outlined: Boolean,
    fab: Boolean
  },

  computed: {
    btnProps () {
      return {
        outlined: this.outlined,
        [this.size]: true,
        color: this.color,
        width: this.width,
        height: this.height,
        to: this.to,
        fab: this.fab
      }
    }
  }
}
</script>
